import styled from "styled-components";

export const NodataWrapper = styled.div<{ $size?: "medium" | "large" }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .content {
    padding: 8px;
    font-weight: 400;
    font-size: ${(props) =>
      props.$size === "large" ? "var(--fontSizeBase500)" : "var(--fontSizeBase300)"};
    line-height: ${(props) =>
      props.$size === "large" ? "var(--lineHeightBase500)" : "var(--lineHeightBase400)"};
    display: flex;
    justify-content: center;
  }
  .description {
    font-size: ${(props) =>
      props.$size === "large" ? "var(--fontSizeBase300)" : "var(--fontSizeBase200)"};
    line-height: ${(props) =>
      props.$size === "large" ? "var(--lineHeightBase300)" : "var(--lineHeightBase200)"};
    display: flex;
    justify-content: center;
  }
`;
